import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "min-h-screen flex flex-col"
};
const _hoisted_2 = {
  class: "relative z-10 flex flex-col h-screen",
  style: {
    "background": "linear-gradient(to bottom, #001f3d, #a8d0e6)"
  }
};
const _hoisted_3 = {
  style: {
    "position": "fixed",
    "left": "0",
    "right": "0",
    "top": "0",
    "z-index": "100"
  }
};
const _hoisted_4 = {
  class: "flex-1 flex flex-col relative w-full",
  style: {
    "margin-top": "3.75rem",
    "height": "calc(100% - 3.75rem)"
  }
};
const _hoisted_5 = {
  class: "flex-1 flex"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QuestionnaireDialog = _resolveComponent("QuestionnaireDialog");
  const _component_FAQDialog = _resolveComponent("FAQDialog");
  const _component_HeaderView = _resolveComponent("HeaderView");
  const _component_router_view = _resolveComponent("router-view");
  const _component_ViewFooter = _resolveComponent("ViewFooter");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[0] || (_cache[0] = _createElementVNode("div", {
    class: "fixed inset-0"
  }, [_createElementVNode("div", {
    class: "relative h-full w-full"
  }, [_createElementVNode("div", {
    class: "absolute inset-0 -z-10 h-full w-full bg-white dark:bg-gray-900 bg-[linear-gradient(to_right,#8080801a_1px,transparent_1px),linear-gradient(to_bottom,#8080801a_1px,transparent_1px)] dark:bg-[linear-gradient(to_right,#ffffff0d_1px,transparent_1px),linear-gradient(to_bottom,#ffffff0d_1px,transparent_1px)] bg-[size:14px_24px]"
  })])], -1)), _createVNode(_component_QuestionnaireDialog), _createVNode(_component_FAQDialog), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_HeaderView, {
    class: "flex-none w-full absolute"
  })]), _createElementVNode("main", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_router_view)]), _createVNode(_component_ViewFooter, {
    class: "flex-none w-full"
  })])])]);
}